
  // Export
  module.exports =
  {

    // Search scripts
    search:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Get the cancelled status
        var cancelled = $('#order-forms').data(APPLICATION._DATA_PREFIX + 'cancelled')

        // Load the order forms
        APPLICATION._APPLICATION.load($('#order-forms'), APPLICATION._PATH_PREFIX + 'order-form/order-forms/' + cancelled, 'OrderForm', 'orderForms')        

      }

    },

    // Create scripts
    create:
    {

      // Method-wide scripts
      _init: function ()
      {

        // On clicking the calendar
        $('#requested_date_calendar').not('.js-ignore').click(function ()
        {
  
          // Get the form
          var form = $(this).closest('form').serialize()
  
          // Get the phase IDs
          var phase_ids = $(this).attr('data-' + APPLICATION._DATA_PREFIX + 'phase_ids')
  
          // Get the date to
          var date_to = $(this).attr('data-' + APPLICATION._DATA_PREFIX + 'date_to')
  
          // Store the datepicker
          APPLICATION._datepicker = function (date)
          {
  
            // Set the due date
            form += '&requested_date=' + date
  
            // Show the custom modal
            APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'order-form/create/' + phase_ids + '/' + date_to + '?send=1' + form, 'OrderForm', 'create')
  
          }
  
          // Get the parts
          var parts = $('#requested_date').val().split('/')
  
          // Open the calendar
          $('#calendar').data(APPLICATION._DATA_PREFIX + 'modal', APPLICATION._PATH_PREFIX + 'calendar/month/' + parts[2] + '/' + parts[1] + '?modal=1&future=1&date=' + parts[2] + '-' + parts[1] + '-' + parts[0]).trigger('click')
  
        }
        ).addClass('js-ignore')

      }

    },

    // Order forms scripts
    orderForms:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Process links
        APPLICATION._APPLICATION.processLinks('#order-forms', 'OrderForm', 'orderForms')

        // Get the development
        var development = $('#development_id')

        // On changing the company
        $('#company_id').not('.js-ignore').change(function ()
        {

          // Get the company ID
          var company_id = $(this).val()

          // If no brand or company
          if ('' === company_id)
          {
            development.next('.dropdown-menu').html('')
          }

          // Otherwise
          else
          {
            APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'development/dropdown/' + company_id + '?development_id=' + development.val(), 'Development', 'dropdown')
          }

        }
        ).addClass('js-ignore').trigger('change')

      }

    },

    // Edit scripts
    edit:
    {

      // Method-wide scripts
      _init: function ()
      {

        // On applying date
        $('.js-apply-date').not('.js-ignore').click(function ()
        {

          // Get the date
          var date = $('.js-date', $(this).closest('tr')).val()

          // If a date
          if ('' !== date)
          {

            // Iterate over the checked rows
            $('.js-row:checked').each(function ()
            {
              $('.js-date', $(this).closest('tr')).val(date)
            }
            )

          }

        }
        ).addClass('js-ignore')

        // On changing the urgency
        $('#urgent').not('.js-ignore').change(function ()
        {

          // The requested date
          var requested_date = $('#requested_date')

          // The urgent requested date
          var requested_date_urgent = $('#requested_date_urgent')

          // If checked
          if (this.checked && requested_date.val() == requested_date.data(APPLICATION._DATA_PREFIX + 'default'))
          {
            requested_date.val(requested_date_urgent.val())
          }

          // Otherwise
          else if (!this.check && requested_date.val() == requested_date_urgent.val())
          {
            requested_date.val(requested_date.data(APPLICATION._DATA_PREFIX + 'default'))
          }

        }
        ).addClass('js-ignore')

        // On changing the packs or items required
        $('.js-packs, .js-items').not('.js-ignore').change(function ()
        {

          // Get the product
          var product = $(this).closest('.js-product')

          // Set quantity
          APPLICATION.OrderForm.edit.setQuantity(product)

          // Get quantity
          APPLICATION.OrderForm.edit.setUsage(product)

        }
        ).addClass('js-ignore')

      },

      // Send
      send: function ()
      {

        // Change the opacity
        $('#modal-box').prepend('<div class="overlay"><div class="spinner-outer"><span class="fa fa-spinner fa-spin spinner"></span></div></div>')

        // Send
        $('#send').val('1')

        // Submit the form
        $('form').submit()

      },

      // Set the quantity
      setQuantity: function (product)
      {

        // Get the quantity
        var quantity = parseInt($('.js-quantity', product).val(), 10)

        // Get the packs
        var packs = parseInt($('.js-packs', product).val(), 10) || 0

        // Get the items
        var items = parseInt($('.js-items', product).val(), 10) || 0

        // Get the quantity required
        var quantity_required = quantity * packs + items

        // Set the quantity required
        $('.js-quantity_required', product).val(quantity_required)

      },

      // Set the usage
      setUsage: function (product)
      {

        var product_category = parseInt($('.js-product_category_id', product).val())

        if (-1 != [1, 2, 3].indexOf(product_category))
        {
          product_category = [1, 2, 3]
        }

        else
        {
          product_category = [product_category]
        }

        var cost = 0.00

        for (var i = 0; i < product_category.length; ++i)
        {

          $('.js-product_category_id[value="' + product_category[i] + '"]').closest('.js-product').each(function ()
          {
         
            var quantity = $('.js-quantity_required', $(this)).val() || 0

            cost += quantity * ($('.js-cost', $(this)).val() || 0)

          }
          )

        }

        var called_off = parseFloat($('.js-called-off[data-categories="' + JSON.stringify(product_category) + '"]').val() || 0.00)

        var required = parseFloat($('.js-required[data-categories="' + JSON.stringify(product_category) + '"]').val() || 0.00)

        var percent = 0.00 == required ? 100 : Math.round((called_off + cost) / required * 100)

        var over = false

        if (percent > 100.00)
        {
          percent = 100.00
          over = true
        }

        var bar = $('.js-progress[data-categories="' + JSON.stringify(product_category) + '"]')

        bar.css('minWidth', '24px')
          .css('width', String(percent) + '%')
          .text(String(percent) + '%')
          .show()

        if (over)
        {
          bar.addClass('progress-bar-danger')
        }
        
        else
        {
          bar.removeClass('progress-bar--danger')
        }

      },

      // Lock
      lock: function ()
      {

        // Iterate over the checked rows
        $('.js-row:checked').each(function ()
        {
          $('.js-lock', $(this).closest('tr')).prop('checked', true)
        }
        )

      }

    },

    // Development scripts
    development:
    {

      // Method-wide scripts
      _init: function ()
      {

        // On changing the company
        $('#company_id').not('.js-ignore').change(function ()
        {

          // Get the company ID
          var company_id = $(this).val()

          // Get the phase
          var phase = $('#phase_id')

          // Load the phases
          APPLICATION._APPLICATION.loadDropdown(phase, APPLICATION._PATH_PREFIX + 'company/phases/' + company_id + '?phase_id=' + phase.val(), 'Company', 'phases')

        }
        ).addClass('js-ignore').trigger('change')

      }

    },

    analysisResults:
    {

      _init: function ()
      {

        APPLICATION._APPLICATION.processLinks('#developments', 'OrderForm', 'analysisResults')

      }

    },

    forecast:
    {

      _init: function()
      {
        this.onChangeCompany()
      },

      onChangeCompany: function ()
      {

        $('#company_id').not('.js-ignore').change(function ()
        {

          var company_id = $(this).val()

          var development = $('#development_id')

          APPLICATION._APPLICATION.loadDropdown(
            development,
            APPLICATION._PATH_PREFIX + 'company/phases/' + company_id + '?phase_id=' + development.val() + '&all_option=1',
            'Company',
            'phases'
          )

        }
        ).addClass('js-ignore').trigger('change')

      }

    }

  }